import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ObservationGroupService as ObservationGroupPublicService } from 'app/mdm/lib/observation-group/observation-group.service';
import { ObservationGroup } from 'app/mdm/lib/observation-group/observation-group';

@Injectable({ providedIn: 'root' })
export class ObservationGroupService extends ObservationGroupPublicService {
  constructor(http: HttpClient) {
    super(http);
  }

  public save(observationGroup: ObservationGroup): Observable<any> {
    if (observationGroup.id) {
      return this.http.put<ObservationGroup>(`${this.baseUrl}/${observationGroup.id}`, observationGroup);
    }
    return this.http.post<ObservationGroup>(this.baseUrl, observationGroup);
  }
}
